import { Button } from 'react-bootstrap';

export class BranchesSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAppointmentLocations: [],
      showSelectedAppointmentLocations: false,
      selectedItemCount: 0,
    };
    compensar.selectedAppointmentPlaces = [];
  }

  /**
   * Verifica si se alcanzó el límite máximo de sedes seleccionadas.
   * @returns {boolean} true si se alcanzó el límite, false en caso contrario.
   */
  enforceItemCheckLimit() {
    var disabled = false;
    var maximumSelections = parseInt(parseText('Form.AppointmentLocation.MaxLocationsToSelectCount'));
    if (this.state.selectedAppointmentLocations.length >= maximumSelections) {
      disabled = true;
    }
    return disabled;
  }

  /**
   * Obtiene las sedes seleccionadas en formato string, separadas por '|', o desde localStorage si no hay selección.
   * @returns {string} Sedes seleccionadas o valor auxiliar.
   */
  getFilteredSelectedLocations() {
    let auxLocation = localStorage.getItem('SedesCodeAux');
    if (compensar?.selectedAppointmentPlaces?.length > 0) {
      let selectedLocations = compensar.selectedAppointmentPlaces.map((x) => x.itemText);
      if (compensar.selectedAppointmentPlaces.length > 1) {
        return selectedLocations.join('|');
      }
      return selectedLocations.join('');
    }
    return auxLocation;
  }

  /**
   * Maneja la deselección de una sede desde la lista de seleccionados.
   * @param {object} evnt - Evento de click.
   * @param {object} removeItem - Sede a remover.
   * @returns {boolean} Siempre retorna false para prevenir el comportamiento por defecto.
   */
  handleDeselectionChildList(evnt, removeItem) {
    var index = compensar.selectedAppointmentPlaces.findIndex((place) => {
      return place.itemId === removeItem.itemId;
    });
    if (index !== -1) {
      compensar.selectedAppointmentPlaces.splice(index, 1);
      this.setState({
        selectedAppointmentLocations: compensar.selectedAppointmentPlaces,
      });
      var checkboxId = 'checkbox' + removeItem.itemId;
      var checkbox = document.getElementById(checkboxId).children[0];
      checkbox.checked = false;
      this.props.checkedSedes(compensar.selectedAppointmentPlaces);
      this.updateDropListSelection(checkbox, evnt);
    }
    return false;
  }

  /**
   * Actualiza la selección de sedes al seleccionar/deseleccionar un checkbox.
   * @param {object} checkbox - Elemento checkbox seleccionado.
   * @param {object} evnt - Evento de selección.
   */
  updateDropListSelection(checkbox, evnt) {
    if (checkbox.checked) {
      compensar.selectedAppointmentPlaces.push({
        itemId: checkbox.value,
        itemText: evnt.target.getAttribute('data-locationDescription'),
        itemAddress: evnt.target.getAttribute('data-locationAddress'),
        itemUri: evnt.target.getAttribute('data-locationUri'),
        selected: checkbox.checked,
      });
    } else {
      var index = compensar.selectedAppointmentPlaces.findIndex((place) => {
        return place.itemId === checkbox.value;
      });
      if (index !== -1) {
        compensar.selectedAppointmentPlaces.splice(index, 1);
      }
    }
    this.setState({
      selectedAppointmentLocations: compensar.selectedAppointmentPlaces,
      showSelectedAppointmentLocations: compensar.selectedAppointmentPlaces.length !== 0 ? true : false,
    });
    this.props.checkedSedes(compensar.selectedAppointmentPlaces);

    dataLayer.push({
      event: 'agendar_cita_medica',
      user_id: compTools.obtenerInformacionUsuario().Nautcli,
      log_status: compTools.obtenerInformacionUsuario().RecienAutenticado,
      login_type: compTools.obtenerInformacionUsuario().TipoIdentificacion === 1 ? 'Personas' : 'Empresas',
      affiliation: 'Salud',
      bread_crumbs: 'servicios-médicos',
      sede: this.getFilteredSelectedLocations(),
      especialidad: localStorage.getItem('especialidad'),
      step: 'Paso 3 Seleccion sede',
    });
  }

  /**
   * Maneja el evento de selección/deselección de una sede desde el dropdown.
   * @param {object} evnt - Evento de click.
   * @returns {boolean} Siempre retorna false para prevenir el comportamiento por defecto.
   */
  handleSelection(evnt) {
    var checkbox = null;
    if (evnt.target.type !== 'checkbox') {
      evnt.preventDefault();
      evnt.stopPropagation();
      checkbox = evnt.target.children[0];
      if (checkbox !== null && checkbox !== undefined) {
        checkbox.checked = !checkbox.checked;
        this.updateDropListSelection(checkbox, evnt);
      }
    } else {
      console.log('fue desde el checkbox');
      checkbox = evnt.target;
      if (checkbox !== null && checkbox !== undefined) {
        this.updateDropListSelection(checkbox, evnt);
      }
    }
    evnt.target.blur();
    return false;
  }

  /**
   * Obtiene la lista de sedes seleccionadas actualmente.
   * @returns {array} Lista de sedes seleccionadas.
   */
  getSelectedLocations() {
    return this.state.selectedAppointmentLocations;
  }

  /**
   * Verifica si una sede está seleccionada.
   * @param {number} itemId - ID de la sede.
   * @returns {boolean} true si está seleccionada, false en caso contrario.
   */
  getSelectedChecksState(itemId) {
    var state = false;
    var item = this.state.selectedAppointmentLocations.filter((item) => parseInt(item.itemId) === itemId)[0];
    if (item !== null && item !== undefined) {
      state = item.selected;
    }
    return state;
  }

  /**
   * Renderiza el componente BranchesSelector (dropdown de sedes con checkboxes).
   * @returns {JSX.Element} Elementos JSX a renderizar.
   */
  render() {
    var dropdownText = this.props.PlaceHolderText;
    if (this.state.selectedAppointmentLocations.length !== 0) {
      dropdownText = this.state.selectedAppointmentLocations.map((location) => location.itemText).join(',');
    } else {
      dropdownText = this.props.PlaceHolderText;
    }
    return (
      <div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-group">
          <button
            type="button"
            className="col-xs-12 col-sm-8 col-md-8 col-lg-8 btn btn-primary btn-sm dropdown-toggle"
            data-toggle="dropdown"
          >
            {dropdownText}
            <span className="caret" />
          </button>
          <ul className="col-xs-12 col-sm-8 col-md-8 col-lg-8 dropdown-menu">
            {this.props.ListItems.map((listItem) => {
              var checkboxId = 'checkbox' + listItem.id;
              return (
                <li>
                  <Button
                    className="btn btn-default small"
                    disabled={this.enforceItemCheckLimit()}
                    data-value={listItem.id}
                    data-locationDescription={listItem.text}
                    data-locationAddress={listItem.address}
                    data-locationUri={listItem.url}
                    id={checkboxId}
                    onClick={this.handleSelection.bind(this)}
                  >
                    <input
                      type="checkbox"
                      className="dropDownCheckbox"
                      data-value={listItem.id}
                      data-locationDescription={listItem.text}
                      data-locationAddress={listItem.address}
                      data-locationUri={listItem.url}
                      id={'chk' + listItem.id}
                      checked={this.getSelectedChecksState(listItem.id)}
                      value={listItem.id}
                    />
                    {listItem.text}
                  </Button>
                </li>
              );
            })}
          </ul>
        </div>
        <div
          style={{
            display: this.state.showSelectedAppointmentLocations ? 'block' : 'none',
          }}
        >
          <div className="col-sm-12 col-md-12 col-lg-12 selected-locations">
            <ul>
              {this.state.selectedAppointmentLocations.map((locationItem) => {
                return (
                  <li>
                    <div className="col-sm-8 col-md-8 col-lg-8">
                      <input
                        className="col-sm-1 col-md-1 col-lg-1"
                        type="checkbox"
                        checked={locationItem.selected}
                        onClick={() => this.handleDeselectionChildList(this, locationItem)}
                      />
                      <h4 className="col-sm-11 col-md-11 col-lg-11">{locationItem.itemText}</h4>
                    </div>
                    <span className="col-sm-2 col-md-2 col-lg-2">
                      <h4>
                        <a href={locationItem.itemUri} target="_blank" rel="noreferrer">
                          Ver Sede
                        </a>
                      </h4>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
